// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-results {
  max-width: 1200px;
  margin: 0 auto;
}

.search-results-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding: 30px 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
}

.search-results-header h1 {
  font-size: 32px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  flex: 1 1;
}

.search-query {
  font-size: 14px;
  color: #6b7280;
}

.search-query code {
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  color: #1f2937;
}

.no-results {
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  color: #6b7280;
}

.no-results code {
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  color: #1f2937;
}

.results-list {
  display: grid;
  gap: 20px;
}

.result-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f3f4f6;
}

.result-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.result-webhook-name {
  font-weight: 600;
  color: #667eea;
  font-size: 14px;
}

.result-timestamp {
  font-size: 12px;
  color: #6b7280;
}

.result-body {
  display: grid;
  gap: 20px;
}

.result-section h4 {
  font-size: 12px;
  color: #374151;
  margin-bottom: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.result-section pre {
  background: #f9fafb;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #e5e7eb;
  overflow-x: auto;
  font-size: 13px;
  font-family: 'Courier New', monospace;
  color: #111827;
  font-weight: 500;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 300px;
  overflow-y: auto;
  line-height: 1.6;
  margin: 0;
}

.event-method {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchResults.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".search-results {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.search-results-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  padding: 30px 40px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  flex-wrap: wrap;\n}\n\n.search-results-header h1 {\n  font-size: 32px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n  flex: 1;\n}\n\n.search-query {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.search-query code {\n  background: #f3f4f6;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  color: #1f2937;\n}\n\n.no-results {\n  text-align: center;\n  padding: 80px 20px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  color: #6b7280;\n}\n\n.no-results code {\n  background: #f3f4f6;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  color: #1f2937;\n}\n\n.results-list {\n  display: grid;\n  gap: 20px;\n}\n\n.result-card {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.result-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #f3f4f6;\n}\n\n.result-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.result-webhook-name {\n  font-weight: 600;\n  color: #667eea;\n  font-size: 14px;\n}\n\n.result-timestamp {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.result-body {\n  display: grid;\n  gap: 20px;\n}\n\n.result-section h4 {\n  font-size: 12px;\n  color: #374151;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.result-section pre {\n  background: #f9fafb;\n  padding: 16px;\n  border-radius: 8px;\n  border: 2px solid #e5e7eb;\n  overflow-x: auto;\n  font-size: 13px;\n  font-family: 'Courier New', monospace;\n  color: #111827;\n  font-weight: 500;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 300px;\n  overflow-y: auto;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.event-method {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
